module.exports = __webpack_public_path__ + "img/Island.ec6bc80c.jpg";